import React from "react"

import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import { Link } from "react-router-dom"

import ApexRadial from "./ApexRadial"

const MonthlyEarning = ({ Total_xCobrar, porcentaje, isLoading }) => {
  return (
    <React.Fragment>
      {" "}
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Meta Cobranza Mensual</CardTitle>
          <Row>
            <Col sm="6">
              <p className="text-muted">Este Mes</p>
              {isLoading ? (
                <React.Fragment>
                  <h3 className="card-title placeholder-glow">
                    <span className="placeholder col-12 placeholder-lg bg-primary"></span>
                  </h3>
                </React.Fragment>
              ) : (
                <h3>
                  {Total_xCobrar.toLocaleString("es-MX", {
                    style: "currency",
                    currency: "MXN",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </h3>
              )}

              <p className="text-muted">
                {isLoading ? (
                  <React.Fragment>
                    <span className="placeholder col-12 placeholder-lg bg-primary"></span>
                  </React.Fragment>
                ) : (
                  <span className="text-success me-2">
                    {" "}
                    12% <i className="mdi mdi-arrow-up"></i>{" "}
                  </span>
                )}{" "}
                del mes anterior
              </p>
              <div className="mt-4">
                <Link
                  to="#"
                  className="btn btn-primary waves-effect waves-light btn-sm"
                >
                  Detalles <i className="mdi mdi-arrow-right ms-1 disabled"></i>
                </Link>
              </div>
            </Col>
            <Col sm="6">
              <div className="mt-4 mt-sm-0">
                <ApexRadial
                  dataColors='["--bs-primary"]'
                  porcentaje={porcentaje}
                  isLoading={isLoading}
                />
              </div>
            </Col>
          </Row>
          <p className="text-muted mb-0"></p>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonthlyEarning
